import { Component } from "react";

import DataTable from "components/DigiHapi/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import ConfirmDialog from "components/DigiHapi/ConfirmDialog";
import MDWizard from "components/DigiHapi/MDWizard";
import Notification from "components/DigiHapi/Notification";

import { GiBarracksTent } from "react-icons/gi";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
	fetchGetLocations,
	fetchAddLocation,
	fetchUpdateLocation,
	fetchDeleteLocation
} from "actions/location";

import Step1 from "./Step1";
import Step2 from "./Step2";

import {
	RESET_LOCATION,
	SET_LOCATION,
	SET_LOCATION_WIZARD_STEP,
	ADD_LOCATION,
	SET_LOCATION_NAME_FR,
	SET_LOCATION_NAME_EN,
	SET_LOCATION_ORDER
} from "actions/types.js";

class LocationWizard extends Component {
	fetchAddLocation = () => {
		const { fetchAddLocation, name, lang, community } = this.props;

		fetchAddLocation({ name, lang, communityId: community._id });
	};

	fetchUpdateLocation = () => {
		const { fetchUpdateLocation, _id, name, lang, order } = this.props;

		fetchUpdateLocation({ _id, name, lang, order });
	};

	render() {
		const {
			update,
			isFetching,
			onClose,
			onChangeCurrentStep,
			wizardCurrentStep
		} = this.props;

		return (
			<Grid item xs={12}>
				<MDWizard
					onClose={onClose}
					onChangeCurrentStep={onChangeCurrentStep}
					currentStep={wizardCurrentStep}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Français",
							stepComponent: Step1,
							stepId: "french"
						},
						{
							stepName: "Anglais",
							stepComponent: Step2,
							stepId: "english"
						}
					]}
					title={
						update ? "Mise à jour d'un hébergement" : "Ajout d'un hébergement"
					}
					finishButtonClick={
						update ? this.fetchUpdateLocation : this.fetchAddLocation
					}
				/>
			</Grid>
		);
	}
}

class LocationsPage extends Component {
	state = {
		br: false,
		color: "info",
		message: null,
		wizard: null,
		locationToDelete: null
	};

	componentDidMount() {
		const { fetchGetLocations, newWizard, community } = this.props;
		fetchGetLocations(community._id);
		if (newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetLocations,
			snackErrorMsg,
			snackInfoMsg,
			newWizard,
			community
		} = this.props;

		if (snackErrorMsg && prevProps.snackErrorMsg !== snackErrorMsg) {
			this.autoCloseMessage();
		}

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetLocations(community._id);
			this.autoCloseMessage();
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	hideAlert = () => {
		this.setState({
			br: false
		});
	};

	autoCloseMessage = () => {
		const { snackErrorMsg, snackInfoMsg } = this.props;

		this.setState({
			br: true,
			message: snackInfoMsg ? snackInfoMsg : snackErrorMsg,
			color: snackInfoMsg ? "info" : "danger"
		});

		if (snackInfoMsg) {
			setTimeout(this.hideAlert, 5000);
		}
	};

	onClose = () => {
		const { fetchGetLocations, community } = this.props;
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_LOCATION
		});
		fetchGetLocations(community._id);
	};

	onChangeCurrentStep = currentStep => {
		this.props.dispatch({
			type: SET_LOCATION_WIZARD_STEP,
			payload: currentStep
		});
	};

	addWizard = (update = true) => {
		this.setState({
			wizard: (
				<ConnectedLocationWizard
					update={update}
					onClose={this.onClose}
					onChangeCurrentStep={this.onChangeCurrentStep}
				/>
			)
		});
	};

	editLocation = (id, name, lang, order) => {
		const { dispatch } = this.props;
		dispatch({
			type: SET_LOCATION,
			payload: id
		});
		dispatch({
			type: SET_LOCATION_NAME_FR,
			payload: name
		});
		if (lang && lang.en) {
			dispatch({
				type: SET_LOCATION_NAME_EN,
				payload: lang.en.name
			});
		}
		dispatch({
			type: SET_LOCATION_ORDER,
			payload: order
		});
	};

	deleteLocation = id => {
		this.props.fetchDeleteLocation(id);
	};

	getRoundButtons = (id, name, lang, order) => {
		return [
			{ color: "info", icon: "edit", onClick: this.editLocation },
			{ color: "error", icon: "delete", onClick: this.delete }
		].map((prop, key) => {
			return (
				<MDButton
					variant="gradient"
					size="small"
					iconOnly
					circular
					color={prop.color}
					disabled={!!this.state?.wizard}
					key={key}
					onClick={() => prop.onClick(id, name, lang, order)}
					sx={{ mx: 0.25 }}
				>
					<Icon>{prop.icon}</Icon>
				</MDButton>
			);
		});
	};

	getLocations = () => {
		const { locations } = this.props;

		const locationsObj = locations.map(({ _id, name, lang, order }) => {
			return {
				name,
				actions: (
					<MDBox display="flex" justifyContent="flex-end">
						{this.getRoundButtons(_id, name, lang, order)}
					</MDBox>
				)
			};
		});
		return locationsObj;
	};

	delete = locationId => {
		this.setState({ locationToDelete: locationId });
	};

	render() {
		const { color, message, wizard, locationToDelete } = this.state;
		const { dispatch, isFetchingList } = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<Card>
						<MDBox
							mx={2}
							mt={-3}
							py={2}
							px={2}
							variant="gradient"
							bgColor="primary"
							borderRadius="lg"
							coloredShadow="primary"
							display="flex"
							alignItems="center"
							color="white"
						>
							<GiBarracksTent size={24} />
							<MDTypography variant="h6" color="white" ml={1.5}>
								Hébergements
							</MDTypography>
						</MDBox>
						<MDBox p={2}>
							<DataTable
								data={this.getLocations()}
								filterable
								columns={[
									{
										Header: "Nom",
										accessor: "name",
										sortable: true,
										filterable: false
									},
									{
										Header: "Actions",
										accessor: "actions",
										sortable: false,
										filterable: false
									}
								]}
								loading={isFetchingList}
								defaultPageSize={5}
								showPaginationTop
								showPaginationBottom={false}
								previousText="Précédent"
								nextText="Suivant"
								rowsText="Lignes"
								noDataText="Aucuns hébergements"
								ofText="sur"
								loadingText="Chargement..."
							/>
						</MDBox>
						<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
							<MDButton
								variant="gradient"
								color="primary"
								onClick={() =>
									dispatch({
										type: ADD_LOCATION
									})
								}
								disabled={!!wizard}
							>
								<Icon>add</Icon>&nbsp;{"Ajout d'un hébergement"}
							</MDButton>
						</MDBox>
					</Card>
				</Grid>
				{wizard}
				<ConfirmDialog
					open={!!locationToDelete}
					message="Êtes-vous sûr de vouloir supprimer l'hébergement ?"
					confirmText="Supprimer"
					onCancel={() => this.setState({ locationToDelete: null })}
					onConfirm={() => {
						this.deleteLocation(locationToDelete);
						this.setState({ locationToDelete: null });
					}}
				/>
				<Notification
					place="br"
					color={color}
					message={message}
					open={this.state.br}
					onClose={this.hideAlert}
				/>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetchingList,
		isFetching,
		_id,
		locations,
		name,
		lang,
		order,
		error,
		nameError,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		wizardCurrentStep
	} = state.locationReducer;

	const { community } = state.entitiesReducer;

	return {
		isFetchingList,
		isFetching,
		_id,
		locations: Object.values(locations),
		name,
		lang,
		order,
		error,
		nameError,
		snackInfoMsg,
		snackErrorMsg,
		newWizard,
		wizardCurrentStep,
		community
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetLocations,
			fetchAddLocation,
			fetchUpdateLocation,
			fetchDeleteLocation
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedLocationWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(LocationWizard);

export default {
	LocationsPage: connect(mapStateToProps, mapDispatchToProps)(LocationsPage),
	LocationWizard: ConnectedLocationWizard
};
